import { useForm } from "react-hook-form";
import { useAtom } from "jotai";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { selectedTableCardInfo } from "../../../../../../app/store";

const schema = z.object({
  name: z.string().optional(),
  tableCode: z.string().optional(),
  percents: z.string().optional(),
  maxPercents: z.string().optional(),
  bonus: z.string().optional(),
  leaderCommission: z.string().optional(),
  leaderBonus: z.string().optional(),
  limit: z.string().optional(),
  valuesAndCommissions: z
    .array(
      z.object({
        value: z.coerce.string(),
        commission: z.coerce.string(),
        leaderCommission: z.coerce.string().optional(),
        max: z.coerce.string().optional(),
      }),
    )
    .optional(),
});

export type FormEditTableData = z.infer<typeof schema>;

export const useTableCardController = () => {
  const methods = useForm<FormEditTableData>({
    resolver: zodResolver(schema),
  });

  const [, setSelectedTableCard] = useAtom(selectedTableCardInfo);

  return {
    methods,
    setSelectedTableCard,
  };
};
